import { useAbility } from 'permissions/hooks/useAbility.ts';
import { Actions, Subjects } from 'permissions/ability.ts';

export const useActivityLogAvailable = () => {
  const ability = useAbility();
  return (
    ability.can(Actions.read, Subjects.bulkProvisioning) ||
    ability.can(Actions.read, Subjects.productsManagement)
  );
};
